import type { VehicleSearchV2QueryParams } from '../types';
import type { IConfigObj } from '@makemydeal/dr-common-utils';
import type { Dispatch } from 'redux';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';

export interface LoggingContext {
    [key: string]: string;
}

export function withNewRelic<
    T extends (queryParams: VehicleSearchV2QueryParams, bffEndpointConfig: IConfigObj) => (dispatch: Dispatch<any, any>) => void
>(original: T, actionName: string, loggingContext?: LoggingContext): T {
    return function (
        this: unknown,
        queryParams: VehicleSearchV2QueryParams,
        bffEndpointConfig: IConfigObj
    ): (dispatch: Dispatch<any, any>) => void {
        logNewRelicPageAction(actionName, { ...queryParams, ...loggingContext });
        return original.call(this, queryParams, bffEndpointConfig);
    } as any as T;
}
